import AjaxClass from "../Forms/Validation/ajaxClass";

export default function loadMoreVehicles() {
    document.addEventListener('click', function(e) {
        const loadMoreBtn = e.target.closest("#load-more");
        if (loadMoreBtn) {
            e.preventDefault();
            loadCards();
        }
    });
    let orderSelect = document.getElementById('order');
    let filterForm = document.getElementById('filterForm');
    orderSelect.addEventListener('change', function(e) {
        filterForm.dispatchEvent(new Event('submit'));
    });
    filterForm.addEventListener('submit', function(e) {
        e.preventDefault();
        loadCards(1);
    });

    function loadCards(defaultPage = false) {
        class LoadCards extends AjaxClass {
            successFunction(html) {
                const cardsDiv = document.getElementById("cardsDiv");
                if (html && !defaultPage) {
                    if (cardsDiv) cardsDiv.insertAdjacentHTML('beforeend', html);
                } else {
                    if (cardsDiv) cardsDiv.innerHTML = html;
                }

                const btn = document.getElementById("load-more");
                const nextPageEl = document.getElementById('nextPage');
                document.getElementById('nextPage').value = parseInt(nextPageEl.value) + 1;
                const lastPageEl = document.getElementById('lastPage');
                if (!nextPageEl) {
                    btn.parentElement.classList.add('d-none');
                    btn.classList.add('d-none');
                } else {
                    let nextPage = parseInt(nextPageEl.value);
                    let lastPage = parseInt(lastPageEl.value);
    
                    btn.parentElement.classList.remove('d-none');
                    btn.classList.remove('d-none');
                    if (btn && nextPage > lastPage) {
                        btn.parentElement.classList.add('d-none');
                        btn.classList.add('d-none');
                    }
                }
            }

            errorFunction() {
            }
        }
        let url = '';
        let page = parseInt(document.getElementById('nextPage').value);
        if (defaultPage) {
            page = defaultPage;
        }
        let formData = new FormData(filterForm);
        formData.append('page', page);
        let dataString = new URLSearchParams(formData).toString();
        
        
        let loadPosts = new LoadCards(null, 'get', url, 'html', dataString);
        loadPosts.sendNoRecaptcha();
    }
}